import * as React from "react";

import { cn } from "@nfp-tracker/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, "aria-label": ariaLabel, id, ...props }, ref) => {
    // If no aria-label or id, fallback to visually hidden label for a11y
    const label = ariaLabel || (id ? undefined : "Input field");
    return (
      <>
        {label && (
          <span className="sr-only" id={id ? `${id}-label` : undefined}>{label}</span>
        )}
        <input
          type={type}
          className={cn(
            "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            className,
          )}
          ref={ref}
          aria-label={ariaLabel || label}
          role="textbox"
          aria-labelledby={id ? `${id}-label` : undefined}
          {...props}
        />
      </>
    );
  },
);
Input.displayName = "Input";

export { Input };
